window.ttx = window.ttx || {};

ttx.events = {};
// module.exports = ttx.events;
ttx.events.on = function (name, callback, context) {
  if (!name || !callback) return;
  // ttx.uba?.frequency?.('全局事件挂载成功，挂载事件名称为: ' + name) // @notranslate
  this._events || (this._events = {});
  const events = this._events[name] || (this._events[name] = []);
  events.push({ callback: callback, context: context });
};
ttx.events.un = function (name, callback) {
  if (!name || !this._events || !this._events[name]) return;
  // ttx.uba?.frequency?.('全局事件卸载成功，被卸载事件名称为: ' + name) // @notranslate
  if (!callback) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this._events[name];
  } else {
    const index = this._events[name].findIndex(function (value) {
      if (value.callback === callback)
        return true;
    });
    if (index !== -1)
      this._events[name]?.splice(index, 1);
  }
};
ttx.events.hasEvent = function (name) {
  if (!name) return;
  return this._events && this._events[name] && this._events[name].length;
};
ttx.events.execute = function (name) {
  if (!name) return;
  const events = this._events ? this._events[name] : null;
  if (!events) return true;
  // ttx.uba?.frequency?.('全局事件执行成功,执行事件名称为: ' + name) // @notranslate
  let result = true;
  const args = Array.prototype.slice.call(arguments, 1);
  events.forEach(function (event) {
    result = event.callback.apply(event.context || this, args) === false ? false : result;
  }, this);
  return result;
};

ttx.promise = function () {
  this.callbacks = [];
};

ttx.promise.prototype = {
  resolve: function (result) {
    this.complete('resolve', result);
  },
  reject: function (result) {
    this.complete('reject', result);
  },
  complete: function (type, result) {
    while (this.callbacks[0])
      this.callbacks.shift()[type](result);
  },
  then: function (successHandler, failedHandler) {
    this.callbacks.push({
      resolve: successHandler,
      reject: failedHandler
    });
    return this;
  }
};
